module.exports = __webpack_public_path__ + "static/media/creek.813d2fc7.wav";